module.exports = __webpack_public_path__ + "static/media/omen.8e6bd9d5.png";